export const tableHeaders = [
  {
    Header: "ID",
    accessor: "id",
  },
  {
    Header: "Nombre",
    accessor: "name",
  },
  {
    Header: "Teléfono",
    accessor: "phone",
  },
  {
    Header: "Servicios",
    accessor: "services",
  },
  {
    Header: "Total",
    accessor: "total",
  },
  {
    Header: "Actions",
    accessor: "actions",
    align: "center",
    sortable: false,
    filterable: false,
  },
];



// WEBPACK FOOTER //
// ./src/views/Configurator/tableHeaders.js